import { ArticleSummary } from 'services/ContentfulService/models/articles'
import React from 'react'
import { DataWrapper } from 'components/patterns/suspense/internals/types'
import { FullRow, GridContainer, ScrollableGridContainer } from './styles'
import { ArticleGridMode, configs } from './config'
import { generateItems, generateItemsAsync } from './generator'

interface Props {
	articles: Array<ArticleSummary>
	rowDividers?: JSX.Element[]
	mode?: ArticleGridMode
}

export const ScrollableArticleGrid: React.FC<React.PropsWithChildren<Props>> = ({ articles, mode = 'standard' }) => {
	const cards = generateItems(mode, articles)
	return <ScrollableGridContainer {...configs[mode].gridProps}>{cards}</ScrollableGridContainer>
}

export const ArticleGrid: React.FC<React.PropsWithChildren<Props>> = ({
	articles,
	rowDividers = [],
	mode = 'standard'
}) => {
	const cards = generateItems(mode, articles)
	const dividers = rowDividers.map(divider => <FullRow key={divider.key}>{divider}</FullRow>)
	dividers.forEach((divider, index) => cards.splice(index * 6 + 2, 0, divider))
	return <GridContainer {...configs[mode].gridProps}>{cards}</GridContainer>
}

interface AsyncProps {
	articles: Array<DataWrapper<ArticleSummary>>
	rowDividers?: JSX.Element[]
	mode?: ArticleGridMode
}

export const ArticleGridAsync: React.FC<React.PropsWithChildren<AsyncProps>> = ({
	articles,
	rowDividers = [],
	mode = 'standard'
}) => {
	const cards = generateItemsAsync(mode, articles)
	const dividers = rowDividers.map(divider => <FullRow key={divider.key}>{divider}</FullRow>)
	dividers.forEach((divider, index) => cards.splice(index * 6 + 2, 0, divider))
	return <GridContainer {...configs[mode].gridProps}>{cards}</GridContainer>
}
